// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-menu {\n  background-color: transparent !important;\n}\n.el-submenu__title {\n  color: #1D2129 !important;\n}\n.el-menu-item {\n  color: #1D2129;\n}", ""]);
// Exports
exports.locals = {
	"menuText": "#1D2129",
	"menuActiveText": "#165DFF",
	"subMenuActiveText": "#165DFF",
	"menuBg": "transparent",
	"menuHover": "#FFFFFF",
	"subMenuBg": "transparent",
	"subMenuHover": "#FFFFFF",
	"sideBarWidth": "220px"
};
module.exports = exports;
